import { Clock } from 'lucide-react';

// Notice for pages whose functionality is a non-functional preview/mock, so
// external users aren't misled into thinking they can transact yet.
export default function ComingSoonBanner({ note }) {
  return (
    <div
      className="mx-5 mt-3 px-3 py-2 rounded-md flex items-start gap-2"
      style={{ background: 'rgba(56,120,190,0.08)', border: '1px solid rgba(56,120,190,0.35)' }}
    >
      <Clock size={14} style={{ color: '#2C5C8F', flexShrink: 0, marginTop: 1 }} />
      <div className="text-[11px] leading-snug" style={{ color: '#2C5C8F' }}>
        <span className="font-bold">Preview / coming soon</span> — {note}
      </div>
    </div>
  );
}
